var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.009,
    height: 42.008,
    viewBox: "0 0 42.009 42.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8541623_book_reader_icon",
    "data-name": "8541623_book_reader_icon",
    d: "M28.881,7.877A7.877,7.877,0,1,0,21,15.753,7.876,7.876,0,0,0,28.881,7.877ZM19.165,19.782c-4.868-2.98-12.753-3.8-16.72-4.024A2.27,2.27,0,0,0,0,17.98V36.26a2.257,2.257,0,0,0,2.173,2.219c3.582.188,10.829.876,15.838,3.4a1.142,1.142,0,0,0,1.68-.974V20.722A1.092,1.092,0,0,0,19.165,19.782Zm20.4-4.024c-3.967.225-11.853,1.044-16.72,4.024a1.112,1.112,0,0,0-.526.954V40.9A1.145,1.145,0,0,0,24,41.879c5.008-2.52,12.251-3.209,15.833-3.4a2.258,2.258,0,0,0,2.173-2.22V17.98A2.271,2.271,0,0,0,39.563,15.757Z",
    fill: "#5b788f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpGuide);
export default __webpack_public_path__ + "static/media/icon_help_guide.0d6acafd3772e2e8be2d4945b4ae8767.svg";
export { ForwardRef as ReactComponent };